import React from "react";
import { Link } from "react-router-dom";
import HavenBrand from "./HavenBrand";
import { ASSETS } from "../lib/brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      style={{
        background: "var(--warm-white)",
        borderTop: "1px solid var(--border-soft)",
        marginTop: 48,
      }}
    >
      <div className="haven-page-shell-wide" style={{ paddingTop: 56, paddingBottom: 48 }}>
        {/* Brand seal — featured */}
        <div className="flex flex-col items-center text-center mb-10">
          <img
            src={ASSETS.logoText}
            alt="The Sewing Haven · est. 2026"
            style={{ width: "min(360px, 80vw)", height: "auto", display: "block", opacity: 0.92 }}
          />
          <p
            className="mt-4 max-w-xl"
            style={{ color: "var(--ink-soft)", fontSize: 13.5, lineHeight: 1.65 }}
          >
            A member-funded sewing studio. No outside investors. Daniel Hanson — certified at 11, 30 years on every brand. We answer to sewists.
          </p>
        </div>

        <div className="haven-divider-grain" style={{ margin: "0 0 32px" }} />

        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <HavenBrand size={36} />
          </div>
          <div>
            <div className="haven-label">Funnel</div>
            <ul className="mt-3 space-y-2" style={{ color: "var(--ink-soft)", fontSize: 13 }}>
              <li><Link to="/" className="hover:text-[var(--gold)]" style={{ textDecoration: "none" }}>Home</Link></li>
              <li><Link to="/diagnose" className="hover:text-[var(--gold)]" style={{ textDecoration: "none" }}>Diagnose Tension</Link></li>
              <li><Link to="/snapshot" className="hover:text-[var(--gold)]" style={{ textDecoration: "none" }}>Confidence Snapshot</Link></li>
              <li><Link to="/embroidery-cost" className="hover:text-[var(--gold)]" style={{ textDecoration: "none" }}>Embroidery Loss Calculator</Link></li>
              <li><Link to="/join" className="hover:text-[var(--gold)]" style={{ textDecoration: "none" }}>Founding Cohort</Link></li>
            </ul>
          </div>
          <div>
            <div className="haven-label">Promise</div>
            <ul className="mt-3 space-y-2" style={{ color: "var(--ink-soft)", fontSize: 13 }}>
              <li>Founding rate locked permanently</li>
              <li>5+ new videos every month</li>
              <li>Member-funded — answers to you</li>
              <li>Roadmap to 90% functionality: Jun–Aug</li>
            </ul>
          </div>
        </div>
        <div className="haven-divider-grain" style={{ margin: "32px 0 16px" }} />
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2" style={{ color: "var(--ink-muted)", fontSize: 11 }}>
          <span>© {new Date().getFullYear()} The Sewing Haven · Built by sewists, for sewists.</span>
          <span>Daniel Hanson · A-Best Sew &amp; Vac · 150 years of family experience</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
